import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const bondScoreTrendSlice = createApi({
  reducerPath: "bondScoreTrend",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["bondScoreTrend"],
  endpoints: (build) => ({
    getBondScoreTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/bond_score/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["bondScoreTrend"],
    }),
  }),
});

export const { useGetBondScoreTrendQuery } = bondScoreTrendSlice;

export const useQueryStateBondScoreTrendSlice = (queryHook, args) => {
  const result = queryHook(args);
  return {
    data: result?.data?.data[0],
    isLoading: result?.isLoading,
    isFetching: result?.isFetching,
    isError: result?.isError,
    error: result?.error,
  };
};
